export default {
  Fafuli_Test: {
    TestButton: '调用'
  }
}
